import { render } from "./Ekipo.vue?vue&type=template&id=f6ac508c&scoped=true"
import script from "./Ekipo.vue?vue&type=script&lang=js"
export * from "./Ekipo.vue?vue&type=script&lang=js"

import "./Ekipo.vue?vue&type=style&index=0&id=f6ac508c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f6ac508c"

export default script